import { render, staticRenderFns } from "./Cleopatra.vue?vue&type=template&id=6407f109&scoped=true&"
import script from "./Cleopatra.vue?vue&type=script&lang=js&"
export * from "./Cleopatra.vue?vue&type=script&lang=js&"
import style0 from "./Cleopatra.vue?vue&type=style&index=0&id=6407f109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6407f109",
  null
  
)

export default component.exports